import { Fragment } from 'react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

export const ErrorMessage = () => {
  return (
    <Fragment>
      <Text size="mega" noMargin>Você ainda não possui vouchers ativos.</Text>
      <Text size="mega" noMargin>Seus vouchers ativos irão aparecer aqui.</Text>
    </Fragment>
  )
}
